module.exports = "<div class=\"kl-scroll {class}\">\n  <div class=\"kl-scroll-wrap {wrapClass}\"\n       r-style=\"{{'max-height': wrapMaxHeight || 'auto'}}\"\n       ref=\"wrap\" on-scroll={this.onScroll($event)}>\n    <div class=\"kl-scroll-wrap__view\" ref=\"resize\">\n      {#inc this.$body}\n    </div>\n  </div>\n  <kl-scroll-bar move={moveX} size={sizeWidth} direction=\"horizontal\" />\n  <kl-scroll-bar move={moveY} size={sizeHeight} direction=\"vertical\" />\n</div>"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/widget/KLScroll/index.html
// module id = 543
// module chunks = 0